import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { VideoItem } from "@/pages/studyCommon/VideoItem";
import { AiAvatar } from "../AiAvatar";

@Component({
    name: "AiVideo",
    components: {
        VideoItem,
        AiAvatar
    }
})
export default class AiVideo extends Vue {
    @Prop() readonly item: any;
    @Prop() readonly courseLabel: any;
}
//@ts-ignore
export { default as AiVideo } from "./index.vue";
